import React from 'react';
import CanvasBG from '../components/CanvasBG';

export default function TestScreen() {
  return (
    <div>
      <CanvasBG />
    </div>
  );
}
